"use client";

import { useEffect } from "react";

export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    document.title = "Error | C444 Game Pakistan";
  }, []);

  return (
    <div
      className="min-h-[40vh] flex flex-col items-center justify-center px-4 py-16 text-center bg-crypterio-dark text-white"
      role="alert"
    >
      <p className="text-sm font-bold uppercase tracking-widest text-gold mb-2">
        Something went wrong
      </p>
      <p className="text-gray-400 max-w-md mb-8 text-sm">
        {error.digest
          ? `Reference: ${error.digest}`
          : "Please try again or reload the page."}
      </p>
      <button
        type="button"
        onClick={() => reset()}
        className="px-6 py-3 bg-gold text-black font-bold rounded-xl hover:bg-yellow-400 transition-colors"
      >
        Try again
      </button>
    </div>
  );
}
